import { render, staticRenderFns } from "./PurchaseTerms.view.vue?vue&type=template&id=4cc3e9ef&"
import script from "./PurchaseTerms.view.vue?vue&type=script&lang=js&"
export * from "./PurchaseTerms.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc3e9ef')) {
      api.createRecord('4cc3e9ef', component.options)
    } else {
      api.reload('4cc3e9ef', component.options)
    }
    module.hot.accept("./PurchaseTerms.view.vue?vue&type=template&id=4cc3e9ef&", function () {
      api.rerender('4cc3e9ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/contract/sign/partials/PurchaseTerms.view.vue"
export default component.exports